<app-create-ticket *ngIf="checkCaseModalInHome" (checkIsCaseModalOpenInHome)= "checkIsCaseModalOpen($event)"></app-create-ticket>
<div class="landingBgColor">
  <!-- <button  id="chatfix" type="button" (click)="handleNavigation('chat-user-interface')"  class="btn btn-primary">LIVE CHAT</button> -->
  <button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == false" type="button" (click)="openChat()"  class="btn btn-primary">LIVE CHAT</button>
  <button  id="chatfix" *ngIf="isSmartViewChat==true && disableLiveChatSHP == true" type="button"  class="btn btn-primary">LIVE CHAT</button>

  <div class="container p-20">
    <div class="row">
      <div class="col-md-12 col-lg-12 col-xl-8">
          
        <!--Quick Links for desktop-->
        <div class="row quickLinkSection" style="place-content: center;" *ngIf="count === 4 || count > 6">
          <span class="col-12 col-md-3 links-block" *ngFor="let ql of col4Links" [ngSwitch]="ql.links.linkURL">
            <a  href={{ql.links.linkURL}} 
              *ngSwitchDefault
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null "
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <div class="card quickLink">
                <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
                <div class="card-body">
                  <h5 class="card-title">{{ql.links.linkText}}</h5>
                  <p class="card-text">{{ql.longDescription}} </p>
                </div>
              </div>
            </a>
            <a (click)="handleNavigate('case')" 
              *ngSwitchCase= "'case'"
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null "
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <div class="card quickLink">
                <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
                <div class="card-body">
                  <h5 class="card-title">{{ql.links.linkText}}</h5>
                  <p class="card-text">{{ql.longDescription}} </p>
                </div>
              </div>
            </a>
            <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == false">
            <a (click)="openChat('chat')" 
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null "
              *ngSwitchCase= "'chat'"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
            <div class="card quickLink">
              <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
              <div class="card-body">
                <h5 class="card-title">{{ql.links.linkText}}</h5>
                <p class="card-text">{{ql.longDescription}} </p>
              </div>
            </div>
          </a>
        </ng-container>

        <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == true" >
          <a id="chatfixCard"
          [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null "
          *ngSwitchCase= "'chat'"
          [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
        <div class="card quickLink">
          <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
          <div class="card-body">
            <h5 class="card-title">{{ql.links.linkText}}</h5>
            <p class="card-text">{{ql.longDescription}} </p>
          </div>
        </div>
      </a>
      </ng-container>

         </span>
        </div>

        <div class="row quickLinkSection" style="place-content: center;" *ngIf="count !== 4 || count <= 6">
          <span class="col-12 col-md-4 links-block" *ngFor="let ql of col3Links" [ngSwitch]="ql.links.linkURL">
            <a href={{ql.links.linkURL}}
              *ngSwitchDefault
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null" 
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <div class="card quickLink">
                <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
                <div class="card-body">
                  <h5 class="card-title">{{ql.links.linkText}}</h5>
                  <p class="card-text">{{ql.longDescription}}</p>
                </div>
              </div>
            </a>
            <a (click)="handleNavigate('case')" 
              *ngSwitchCase= "'case'"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <div class="card quickLink">
                <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
                <div class="card-body">
                  <h5 class="card-title">{{ql.links.linkText}}</h5>
                  <p class="card-text">{{ql.longDescription}}</p>
                </div>
              </div>
            </a>

            <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == false">
            <a (click)="openChat('chat')" 
              *ngSwitchCase= "'chat'"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <div class="card quickLink">
                <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
                <div class="card-body">
                  <h5 class="card-title">{{ql.links.linkText}}</h5>
                  <p class="card-text">{{ql.longDescription}}</p>
                </div>
              </div>
            </a>
            </ng-container>
            <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == true">
            <a id="chatfixCard"
            *ngSwitchCase= "'chat'"
            [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
            <div class="card quickLink" >
              <i class="card-img-top {{ql.iconClass}} quickLinkIcon" aria-hidden="true"></i>
              <div class="card-body">
                <h5 class="card-title">{{ql.links.linkText}}</h5>
                <p class="card-text">{{ql.longDescription}}</p>
              </div>
            </div>
          </a>
          </ng-container>

          </span>
        </div>
        <!--Quick Links for mobile-->
        <div class="quicklinks-mobile">
          <span class="quickLink-chip" *ngFor="let ql of mobileLinks"  [ngSwitch]="ql.links.linkURL">
            <a href={{ql.links.linkURL}}
              *ngSwitchDefault
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <i class="card-img-top {{ql.iconClass}} " aria-hidden="true"></i>
              <span class="card-title">{{ql.links.linkText}}</span>
            </a>

            <a (click)="handleNavigate('case')"
              *ngSwitchCase= "'case'"
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <i class="card-img-top {{ql.iconClass}} " aria-hidden="true"></i>
              <span class="card-title">{{ql.links.linkText}}</span>
            </a>

            <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == false">
            <a (click)="openChat('chat')"
              *ngSwitchCase= "'chat'"
              [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null"
              [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
              <i class="card-img-top {{ql.iconClass}} " aria-hidden="true"></i>
              <span class="card-title">{{ql.links.linkText}}</span>
            </a>
            </ng-container>
            <ng-container *ngIf="isSmartViewChat==true && disableLiveChatSHP == true">
              <a id="chatfixCardMobile"
                *ngSwitchCase= "'chat'"
                [class.disabled]="ql.links.linkURL === '' || ql.links.linkURL === null"
                [attr.target]="ql.links.openLinkInNewWindow?'_blank':'_self'">
                <i class="card-img-top {{ql.iconClass}} " aria-hidden="true"></i>
                <span class="card-title">{{ql.links.linkText}}</span>
              </a>
              </ng-container>
  

          </span>
        </div>

        <div class="row supportSection" *ngIf="ghDisableTopic!=true && helpTopic.length > 0">
          <div class="card supportlink">
            <div class="card-header d-flex justify-content-between">
              <div class="">
                <strong>{{ghTopic}}</strong>
              </div>
              <div class="">
                <a (click)="handleNavigation('browse')" style="cursor: pointer;" class="p-0 link-offset-2 link-underline link-underline-opacity-0">{{ghBrowseAll}} </a>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-sm-6" *ngFor="let ht of helpTopic">
                  <div *ngIf="ht.externalUrl!='null' && ht.navigation==null">
                  <a class="chip btn btn-primary top-articles-support-tooltip" (click)="navigate(ht.pk)" >
                    <div class="topic-name" tooltip={{ht.stepName}} placement="top" show-delay="100">{{ht.stepName}}</div>
                    <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
                  </a>
                </div>
                <div *ngIf="ht.externalUrl==''">
                  <a class="chip btn btn-primary top-articles-support-tooltip" (click)="navigate(ht.pk)" >
                    <div class="topic-name" tooltip={{ht.stepName}} placement="top" show-delay="100">{{ht.stepName}}</div>
                    <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
                  </a>
                  </div>
                  <div *ngIf="ht.navigation=='_blank'">
                    <a class="chip btn btn-primary top-articles-support-tooltip" href="{{ht.externalUrl}}"  target="_blank" >
                      <div class="topic-name"  tooltip={{ht.stepName}} placement="top" show-delay="100" >{{ht.stepName}}</div>
                      <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
                    </a>
                  </div>
                  <div *ngIf="ht.navigation=='false' && ht.externalUrl">
                    <a class="chip btn btn-primary top-articles-support-tooltip" href="{{ht.externalUrl}}"  target="_blank" >
                      <div class="topic-name"  tooltip={{ht.stepName}} placement="top" show-delay="100" >{{ht.stepName}}</div>
                      <span class="top-articles-support-tooltip-text px-1 py-0" style="pointer-events : none;">{{ht.stepName}}</span>
                    </a>
                  </div>
                 
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <div class="col-sm-4 col-md-12 col-lg-12 col-xl-4 contact-link">
        <div class="rightSection">
          <div class="card" style="width: 100%;">
            <div class="card-header" *ngIf="contact?.footerText?.length > 0">
              <strong>{{contactTitle}}</strong>
            </div>
            <div class="card-body" *ngIf="contact?.footerText?.length > 0">
              <a href="tel:{{this.contactDetails?.callNumber}}" *ngIf="this.contactDetails.callNumberContent">
                <div class="contact-items"> <span> <i class={{contactDetails.callNumberIcon}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.callNumberContent}}
                </div>
              </a>
              <a href="tel:{{this.contactDetails?.callNumber2}}" *ngIf="this.contactDetails.callNumberContent2">
                <div class="contact-items"> <span> <i class={{contactDetails.callNumberIcon2}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.callNumberContent2}}
                </div>
              </a>
              <a href="tel:{{this.contactDetails?.callNumber3}}" *ngIf="this.contactDetails.callNumberContent3">
                <div class="contact-items"> <span> <i class={{contactDetails.callNumberIcon3}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.callNumberContent3}}
                </div>
              </a>
              <a href="tel:{{this.contactDetails?.callNumber4}}" *ngIf="this.contactDetails.callNumberContent4">
                <div class="contact-items"> <span> <i class={{contactDetails.callNumberIcon4}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.callNumberContent4}}
                </div>
              </a>
              <a href="tel:{{this.contactDetails?.callNumber5}}" *ngIf="this.contactDetails.callNumberContent5">
                <div class="contact-items"> <span> <i class={{contactDetails.callNumberIcon5}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.callNumberContent5}}
                </div>
              </a>
              <a [routerLink]="['../chat-user-interface']" *ngIf=" this.contactDetails.chatContent && isSmartViewChat==true && disableLiveChatSHP == false" (click)="openChat()" >
                <div class="contact-items"><span> <i class={{contactDetails.chatIcon}} aria-hidden="true"></i>
                  </span> {{this.contactDetails.chatContent}}</div>
              </a>
              <a [routerLink]="['../chat-user-interface']" *ngIf=" this.contactDetails.chatContent && isSmartViewChat==true && disableLiveChatSHP == true" id="chatfixLink" >
                <div class="contact-items"><span> <i class={{contactDetails.chatIcon}} aria-hidden="true"></i>
                  </span> {{this.contactDetails.chatContent}}</div>
              </a>

               <a style="color:#2196f3; cursor:pointer;" (click)="handleNavigation('createcase')" *ngIf="this.contactDetails.createCase">
                <div class="contact-items"> <span> <i class={{contactDetails.createCaseIcon}} aria-hidden="true"></i>
                  </span>
                  {{this.contactDetails.createCase}}
                </div>
              </a>

              <a *ngIf="this.contactDetails.additionalInfo" style="color:#2196f3;">
                <div class="contact-items">
                  <span [innerHTML]="this.contactDetails.additionalInfo">
                </span>
                </div>
              </a>
            </div>
            
            <div class="card-header" *ngIf="topArticle.total > 0">
              <strong>{{articleTitle}}</strong>
            </div>
            <div class="card-body" *ngIf="topArticle.total > 0">

              <ul style="list-style-type:none;padding-left: 20px;">
                <!-- <a href="#" *ngFor="let article of topArticle.items"> -->
                  <a class="top-articles-tooltip" *ngFor="let article of topArticle.items; let i = index" [routerLink]="['../article']" [queryParams]="{articleId: article.article_id}">
                  <li class="toparticles-block" *ngIf="i<topArticle.total">{{article.article_title}}</li>
                  <span class="top-articles-tooltip-text" style="pointer-events : none;">{{article.article_title}}</span>
                </a>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>